import axios from "axios";
import { getToken } from "./auth";

const API_URL = process.env.REACT_APP_ODIN_API_URL;
const odinApi = axios.create({
  baseURL: API_URL,
  responseType: "json",
});

odinApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default odinApi;
